import React from "react";
import { Card, CardContent } from "../ui/card";
import ItemDetails from "./ItemDetails";
import AssignableItemsSection from "./AssignableItemsSection";
import LoadingState from "../LoadingState";

const AssignmentContentArea = ({
  selectedItem,
  config,
  userDetails,
  assignableItems,
  selectedAssignableItems,
  onToggleAssignableItem,
  formData,
  onFormChange,
  validationErrors,
  isContentLoading,
  onShowPermissions,
  groups,
  onPermissionsImported,
}) => {
  if (isContentLoading) {
    return (
      <div className="bg-customLightBlue rounded-t-xl flex-1">
        <LoadingState
          message={`Loading ${config.itemLabel.toLowerCase()} details...`}
        />
      </div>
    );
  }

  return (
    <Card className="bg-customLightBlue shadow-none flex-1 flex flex-col min-h-0">
      <CardContent className="space-y-6 bg-customLightBlue rounded-t-xl shadow-none flex-1 flex flex-col min-h-0 pt-1">
        <ItemDetails
          selectedItem={selectedItem}
          config={config}
          userDetails={userDetails}
          formData={formData}
          onFormChange={onFormChange}
          validationErrors={validationErrors}
          onShowPermissions={onShowPermissions}
          groups={groups}
          onPermissionsImported={onPermissionsImported}
        />

        <div className="flex-1 min-h-0">
          <AssignableItemsSection
            assignableItems={assignableItems}
            selectedAssignableItems={selectedAssignableItems}
            onToggleAssignableItem={onToggleAssignableItem}
            config={config}
            userDetails={userDetails}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default AssignmentContentArea;
